import React from 'react';
import { cx } from './cx';

export interface CardProps {
  as?: 'div' | 'section' | 'article' | 'aside';
  padding?: 'none' | 'sm' | 'md';
  title?: React.ReactNode;
  description?: React.ReactNode;
  /** Right-aligned header actions (buttons, badges). */
  actions?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

const PADDING = { none: '', sm: 'p-3', md: 'p-4 @bp-sm:p-5' } as const;

/** The one card surface: opaque, 12px corners, the style's card treatment (k-card: edge, shadow, highlight). */
export default function Card({ as: Tag = 'div', padding = 'md', title, description, actions, className, children }: CardProps) {
  const hasHead = title != null || description != null || actions != null;
  return (
    <Tag className={cx('flex min-w-0 flex-col gap-4 rounded-container border k-card bg-card', PADDING[padding], className)}>
      {hasHead ? (
        <div className="flex min-w-0 items-start justify-between gap-3">
          <div className="flex min-w-0 flex-col gap-1">
            {title != null ? <h2 className="m-0 font-display k-heading text-title text-primary">{title}</h2> : null}
            {description != null ? <p className="m-0 font-ui text-small text-secondary">{description}</p> : null}
          </div>
          {actions != null ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </Tag>
  );
}
